import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import { getLoginStatus } from '@/http/api/user'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        userInfo: null, // 用户信息
        subjectData: null, // 科室信息
        subjectVisible: false, // 科室信息弹窗
        params: null,// 检索参数
    },
    getters: {},
    mutations: {
        setUserInfo (state, data) {
            state.userInfo = data
        },
        setsubjectData (state, data) {
            state.subjectData = data
        },
        setsubjectVisible (state, data) {
            state.subjectVisible = data
        },
        setparams (state, data) {
            state.params = data
        },
    },
    actions: {
        getToken (context) {
            return new Promise((resolve, reject) => {
                getLoginStatus().then(res => {
                    if (res.data.token) {
                        sessionStorage.setItem('token', res.data.token)
                        router.go(0)
                    }
                }).catch(error => { })
            })
        },
        
    },
    modules: {}
})